import el from "@cypherpotato/el";

export function CommandBar(...children) {
    return el(".command-bar",
        ...children
    )
}